module.exports = __webpack_public_path__ + "media/images/emblems/Longirod-coat_of_arms-357fdb6e03c1b36a33b799b90a8dd3e6.svg";